module.exports = __webpack_public_path__ + "static/media/inspectionIcon.9b52ae52.svg";